import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { Picture } from "@/components/wpl/image/src";

export interface UniformImageProps {
    source: string;
    altText?: string;
    width?: string;
    maxWidth?: string;
    height?: string;
    maxHeight?: string;
    objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
    objectPosition?: string;
    tabletWidth?: string;
    desktopWidth?: string;
    tabletHeight?: string;
    desktopHeight?: string;
    makeCircle?: boolean;
}

// eslint-disable-next-line complexity
const UniformImage = ({
    source,
    altText = "",
    width,
    maxWidth,
    height,
    maxHeight,
    objectFit,
    objectPosition,
    tabletWidth,
    desktopWidth,
    tabletHeight,
    desktopHeight,
    makeCircle = false
}: UniformImageProps) => {
    const imageStyle = {
        maxWidth,
        maxHeight,
        objectFit,
        objectPosition
    };

    const widthStyle = css({
        width: width ? width : "auto"
    });
    const heightStyle = css({
        height: height ? height : "auto"
    });

    const tabletWidthStyle = css({
        [media.above.sm]: {
            width: tabletWidth ? tabletWidth : "auto"
        }
    });
    const desktopWidthStyle = css({
        [media.above.md]: {
            width: desktopWidth ? desktopWidth : "auto"
        }
    });
    const tabletHeightStyle = css({
        [media.above.sm]: {
            height: tabletHeight ? tabletHeight : "auto"
        }
    });
    const desktopHeightStyle = css({
        [media.above.md]: {
            height: desktopHeight ? desktopHeight : "auto"
        }
    });

    // @ts-ignore
    const responsiveStyles = css([
        width && widthStyle,
        height && heightStyle,
        tabletWidth && tabletWidthStyle,
        desktopWidth && desktopWidthStyle,
        tabletHeight && tabletHeightStyle,
        desktopHeight && desktopHeightStyle
    ]);

    const makeCircleStyle = css({
        borderRadius: "50%"
    });

    return (
        <Picture
            image={{ src: source, alt: altText }}
            style={imageStyle}
            css={[responsiveStyles, makeCircle && makeCircleStyle]}
        />
    );
};

export default UniformImage;
